import { call, put, takeLatest /*select*/ } from "redux-saga/effects";

import { ApiService, SlideClassification } from "pwapi";

import {
  AI_OUTPUT_REQUEST,
  AI_OUTPUT_FAILURE,
  AI_OUTPUT_SUCCESS,
} from "../actions/constants";

function* fetchAIOutputRequest(action: any): any {
  const { id } = action.payload;
  try {
    const result: SlideClassification = yield call(
      ApiService.retrieveSlideClassification1,
      { id }
    );
    // Back end query successful (regardless of anything that happened with S3):
    yield put({
      type: AI_OUTPUT_SUCCESS,
      payload: result,
    });
  } catch (e) {
    yield put({
      type: AI_OUTPUT_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* aiSaga() {
  yield takeLatest(AI_OUTPUT_REQUEST, fetchAIOutputRequest);
}
